import ResellerDashboard from './ResellerDashboard'
import AdminDashboard from './AdminDashboard'
import { useSelector } from '../../store/store'
import { USER_ROLES } from '../../constants'

const Dashboard = () => {
  const role = useSelector((state) => state.user.userInfo.role)
  if (!role) throw new Error('Role is not defined')

  const isAdmin = [USER_ROLES.ADMIN.value, USER_ROLES.INTERNAL_USER.value].includes(role)

  const isReseller = [
    USER_ROLES.EXTERNAL_DIRECT_CUSTOMER.value,
    USER_ROLES.EXTERNAL_RESELLER.value,
    USER_ROLES.EXTERNAL_RESELLER_CUSTOMER.value,
    USER_ROLES.EXTERNAL_USER_WHITE_LABEL.value,
  ].includes(role)

  if (isAdmin) return <AdminDashboard />
  if (isReseller) return <ResellerDashboard />

  return null
}

export default Dashboard
